import api from "@/api/api-v2-config";

export async function getJobcardListAxios(status) {    
    const statusParam = status == null ? "" :  `&status=${status}`;
    return await api.get(`jobcards?pageNumber=1&pageSize=1000${statusParam}`);
}

export async function getJobcardIdAxios(id) {    
    const response = await api.get("jobcards/" + id);
    console.log("API Response:", response);
    return response;
}


export async function getJobcardDemandAxios() {    
    return await api.get("jobcards/demand");
}


export async function getJobcardFileAxios(id) {    
    return await api.get("jobcards/files?ReferenceID="+id+"&PageNumber=1&PageSize=1000");
}

export async function postJobcardFileAxios(file) {    
    return await api.post("/jobcards/files/upload",file);
}
export async function postMultipleJobcardFileAxios(file) {    
    return await api.post("/jobcards/files/uploads",file);
}
export async function deleteJobcardFileAxios(id) {    
    return await api.delete("/jobcards/files/"+ id);
}
export async function deleteJobcardAxios(Jobcards) {    
    return await api.delete("jobcards", Jobcards);
}

export async function postJobcardAxios(Jobcards) {    
    return await api.post("jobcards", Jobcards);
}

export async function putJobcardAxios(Jobcards) {    
    return await api.put("jobcards", Jobcards);
}

export async function putJobcardStatusAxios(Jobcards) {    
    return await api.put("jobcards/status", Jobcards);
}

export async function putMultipleJobCard(Jobcards) {    
    return await api.put("jobcards/liststatus", Jobcards);
}

export async function getJobcardPriorityAxios() {    
    return await api.get("jobcards/prioritylist");
}

export async function downloadJobcardDocument(id) {
    api.defaults.headers["responseType"] = "blob";
    return await api.get("jobcards/files/download/" + id);
}

export async function postJobcardBatchTimesheetAxios(Jobcards) {    
    return await baseapi.post(`tenants/JobCard/submitbatchtimesheets`, Jobcards);
}